module.exports = __webpack_public_path__ + "img/WALLPAPER_MELHOR_VERSAO.c1cd6d26.png";